// Centralized API base URL builder.
// Uses REACT_APP_API_BASE / window.$Env.backendUrl only for production.
// In development we prefer root-relative paths, so CRA dev server proxy can avoid browser CORS.

const isDevelopment = ['localhost', '127.0.0.1'].includes(window.location.hostname);
const envBase = (((window as any).$Env as any).backendUrl || ((window as any).process?.env?.REACT_APP_API_BASE || '') as string).trim();
const RAW_BASE = isDevelopment ? '' : envBase;
// Remove trailing slashes to avoid double slashes
const STRIPPED_BASE = RAW_BASE.replace(/\/+$/, '');

export const API_BASE = STRIPPED_BASE;

/**
 * Build a full API URL.
 * - Accepts paths with or without leading slash
 * - If REACT_APP_API_BASE is set, prefixes it
 * - Otherwise returns a root-relative path for CRA dev server
 */
export function apiUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  if (API_BASE) return `${API_BASE}${p}`;
  return p; // fall back to relative URL in development
}
